// Instance queryClient per-app (v0.2.0 factory pattern)
import { createQueryClient } from '@crm/api-client'

export const queryClient = createQueryClient()
